import React from 'react'
import Cartpage from '../Components/Cartpage/Cartpage'

export const Cart = () => {
  return (
    <div>
      <Cartpage/>
    </div>
  )
}

export default Cart